export const DASH = "—";

export const EQUIPMENT_PASSPORT_TYPES = {
  transformers: {
    slug: "transformers",
    alias: "substation_transformers",
    label: "Трансформатор",
    pluralLabel: "Трансформаторлар",
    maintenanceAliases: ["sub_transformer_maintenances"],
    accidentAliases: ["sub_transformer_accidents"],
    titleKeys: ["name", "transformer_type"],
    fields: [
      { key: "name", label: "Номи" },
      { key: "transformer_type", label: "Тури" },
      { key: "rated_power_mva", label: "Қувват (МВА)" },
      { key: "voltage", label: "Кучланиш (кВ)" },
      { key: "allowed_nominal_current_a", label: "Рухсат этилган номинал токи (A)" },
      { key: "max_load_current_a", label: "Максимал юклама токи, факт бўйича (A)" },
      { key: "serial_number", label: "Серия рақами" },
      { key: "inventory_number", label: "Инвентар рақами" },
      { key: "manufacture_year", label: "Ишлаб чиқарилган йили" },
      { key: "start_year", label: "Ишга туширилган йили" },
    ],
  },
  breakers: {
    slug: "breakers",
    alias: "substation_breakers",
    label: "Ўчиргич",
    pluralLabel: "Ўчиргичлар",
    maintenanceAliases: ["sub_breaker_maintenances"],
    accidentAliases: ["sub_breaker_accidents"],
    titleKeys: ["name", "breaker_type"],
    fields: [
      { key: "name", label: "Номи" },
      { key: "breaker_type", label: "Тури" },
      { key: "voltage", label: "Кучланиш (кВ)" },
      { key: "serial_number", label: "Серия рақами" },
      { key: "manufacture_year", label: "Ишлаб чиқарилган йили" },
      { key: "start_year", label: "Ишга туширилган йили" },
    ],
  },
  disconnectors: {
    slug: "disconnectors",
    alias: "substation_disconnectors",
    label: "Ажратгич",
    pluralLabel: "Ажратгичлар",
    maintenanceAliases: ["sub_disconnector_maintenances"],
    accidentAliases: [],
    titleKeys: ["name", "disconnector_type"],
    fields: [
      { key: "name", label: "Номи" },
      { key: "disconnector_type", label: "Тури" },
      { key: "voltage", label: "Кучланиш (кВ)" },
      { key: "poles_count", label: "Қутблар сони" },
      { key: "serial_number", label: "Серия рақами" },
      { key: "manufacture_year", label: "Ишлаб чиқарилган йили" },
      { key: "start_year", label: "Ишга туширилган йили" },
    ],
  },
  "current-transformers": {
    slug: "current-transformers",
    alias: "substation_current_transformers",
    label: "Ток трансформатори",
    pluralLabel: "Ток трансформаторлари",
    maintenanceAliases: ["ct_maintenances", "sub_current_transformer_maintenances"],
    accidentAliases: [],
    titleKeys: ["name", "ct_type"],
    fields: [
      { key: "name", label: "Номи" },
      { key: "ct_type", label: "Тури" },
      { key: "voltage", label: "Кучланиш (кВ)" },
      { key: "serial_number", label: "Серия рақами" },
      { key: "manufacture_year", label: "Ишлаб чиқарилган йили" },
      { key: "start_year", label: "Ишга туширилган йили" },
    ],
  },
  "voltage-transformers": {
    slug: "voltage-transformers",
    alias: "substation_voltage_transformers",
    label: "Кучланиш трансформатори",
    pluralLabel: "Кучланиш трансформаторлари",
    maintenanceAliases: ["vt_maintenances", "sub_voltage_transformer_maintenances"],
    accidentAliases: [],
    titleKeys: ["name", "vt_type"],
    fields: [
      { key: "name", label: "Номи" },
      { key: "vt_type", label: "Тури" },
      { key: "voltage", label: "Кучланиш (кВ)" },
      { key: "serial_number", label: "Серия рақами" },
      { key: "manufacture_year", label: "Ишлаб чиқарилган йили" },
      { key: "start_year", label: "Ишга туширилган йили" },
    ],
  },
  reactors: {
    slug: "reactors",
    alias: "substation_reactors",
    label: "Реактор",
    pluralLabel: "Реакторлар",
    maintenanceAliases: ["sub_reactor_maintenances"],
    accidentAliases: [],
    titleKeys: ["name", "reactor_type"],
    fields: [
      { key: "name", label: "Номи" },
      { key: "reactor_type", label: "Тури" },
      { key: "serial_number", label: "Завод рақами" },
      { key: "manufacture_year", label: "Ишлаб чиқарилган йили" },
      { key: "start_year", label: "Ишга туширилган йили" },
      { key: "voltage", label: "Номинал кучланиш (кВ)" },
      { key: "nominal_current_a", label: "Номинал ток (А)" },
      { key: "inductive_resistance_ohm", label: "Номинал индуктив қаршилик (Ом)" },
      { key: "thermal_withstand_time_s", label: "Термик стойклик вақти (с)" },
      { key: "electrodynamic_withstand_current_a", label: "Электродинамик стойклик токи (А)" },
      { key: "thermal_withstand_current_a", label: "Ток термик стойкости (А)" },
      { key: "reactor_losses_kw", label: "Йўқотишлар (кВт)" },
      { key: "specific_creepage_distance_cm_per_kv", label: "Ташқи изоляция йўли (см/кВ)" },
    ],
  },
  batteries: {
    slug: "batteries",
    alias: "substation_batteries",
    label: "Аккумулятор",
    pluralLabel: "Аккумуляторлар",
    maintenanceAliases: ["sub_battery_maintenances"],
    accidentAliases: [],
    titleKeys: ["battery_type", "serial_number"],
    fields: [
      { key: "battery_type", label: "Тури" },
      { key: "serial_number", label: "Серия рақами" },
      { key: "manufacture_year", label: "Ишлаб чиқарилган йили" },
      { key: "start_year", label: "Ишга туширилган йили" },
      { key: "cells_count", label: "Элементлар сони" },
      { key: "capacity_ah", label: "Сиғим (Аҳ)" },
      { key: "element_mass_kg", label: "Элемент массаси (кг)" },
    ],
  },
  arresters: {
    slug: "arresters",
    alias: "substation_arresters",
    label: "Разрядник",
    pluralLabel: "Разрядниклар",
    maintenanceAliases: ["sub_arrester_maintenances"],
    accidentAliases: [],
    titleKeys: ["name", "arrester_type"],
    fields: [
      { key: "name", label: "Номи" },
      { key: "arrester_type", label: "Тури" },
      { key: "serial_number", label: "Завод рақами" },
      { key: "manufacture_year", label: "Ишлаб чиқарилган йили" },
      { key: "start_year", label: "Ишга туширилган йили" },
      { key: "voltage_class_kv", label: "Кучланиш синфи (кВ)" },
      { key: "max_permitted_voltage_kv", label: "Максимал рухсат этилган кучланиш (кВ)" },
      { key: "nominal_discharge_current_ka", label: "Номинал разряд токи (кА)" },
      { key: "throughput_current_a", label: "Пропуск қуввати (А)" },
      { key: "height_m", label: "Баландлиги (м)" },
      { key: "weight_kg", label: "Массаси (кг)" },
    ],
  },
};

export const EQUIPMENT_TYPE_ORDER = Object.keys(EQUIPMENT_PASSPORT_TYPES);

export function hasValue(value) {
  return value !== undefined && value !== null && String(value).trim() !== "";
}

export function displayValue(value) {
  if (!hasValue(value)) return DASH;
  if (typeof value === "object") return String(value.id ?? value.name ?? DASH);
  return String(value);
}

export function formatDate(value) {
  if (!hasValue(value)) return DASH;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return displayValue(value);
  return date.toLocaleDateString("ru-RU");
}

export function sortByDateDesc(items, keys = ["event_date", "date", "event_datetime", "date_created"]) {
  return (Array.isArray(items) ? items : [])
    .slice()
    .sort((a, b) => {
      const aTime = keys.map((key) => new Date(a?.[key] || 0).getTime()).find((v) => Number.isFinite(v) && v > 0) || 0;
      const bTime = keys.map((key) => new Date(b?.[key] || 0).getTime()).find((v) => Number.isFinite(v) && v > 0) || 0;
      return bTime - aTime;
    });
}

export function getEquipmentItems(source, type) {
  const cfg = EQUIPMENT_PASSPORT_TYPES[type];
  if (!cfg) return [];
  const items = source?.[cfg.alias];
  return Array.isArray(items) ? items : [];
}

export function getEquipmentTitle(item, cfg) {
  const parts = (cfg.titleKeys || [])
    .map((key) => item?.[key])
    .filter(hasValue)
    .map(String);
  if (parts.length) return parts.join(" / ");
  return `${cfg.label} #${item?.id || DASH}`;
}

export function getEquipmentUrl(type, id) {
  return `/equipment/${encodeURIComponent(type)}/${encodeURIComponent(id)}`;
}

export function getFieldRows(item, cfg) {
  return (cfg?.fields || []).map((field) => ({
    ...field,
    value: item?.[field.key],
  }));
}

export function getMaintenanceItems(item, cfg) {
  const items = (cfg?.maintenanceAliases || []).flatMap((alias) =>
    Array.isArray(item?.[alias]) ? item[alias] : []
  );
  return sortByDateDesc(items);
}

export function getAccidentItems(item, cfg) {
  const items = (cfg?.accidentAliases || []).flatMap((alias) =>
    Array.isArray(item?.[alias]) ? item[alias] : []
  );
  return sortByDateDesc(items);
}

export function getAllEquipmentGroups(source) {
  return EQUIPMENT_TYPE_ORDER.map((type) => ({
    type,
    cfg: EQUIPMENT_PASSPORT_TYPES[type],
    items: getEquipmentItems(source, type),
  }));
}

export function getEquipmentTotal(source) {
  return getAllEquipmentGroups(source).reduce((sum, group) => sum + group.items.length, 0);
}

export function getFileId(file) {
  const raw = file?.directus_files_id ?? file?.file_id ?? file?.id ?? file;
  if (!raw) return null;
  if (typeof raw === "object") return raw.id || null;
  return raw;
}

export function collectRecordFiles(records) {
  return (Array.isArray(records) ? records : []).flatMap((record) =>
    (Array.isArray(record?.files) ? record.files : []).map((file) => ({
      ...file,
      record_id: record.id,
      record_topic: record.topic || record.comment || null,
      record_date: record.event_date || record.date || record.date_created || null,
    }))
  );
}
